<template>
  <div class="xqleft">
    <div class="chengshi">
      <div>郑州第一基站</div>
      <div style="font-size:14px"><img src="@/assets/dw.png" style="margin-right:10px">郑州</div>
    </div>
    <div class="llist">
      <ul>

        <li>
          <h1 class="mingcheng">直流输出电压</h1>
          <h2 class="shuzhi ">{{ info.direct_voltage_output }}<span class="danwei">V</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">总负载电流</h1>
          <h2 class="shuzhi ">{{ info.load_current_total }}<span class="danwei">A</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">电池总电流</h1>
          <h2 class="shuzhi ">{{ info.current_total }}<span class="danwei">A</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">均充电压值</h1>
          <h2 class="shuzhi "><span class="danwei">V</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">浮充电压值</h1>
          <h2 class="shuzhi "><span class="danwei">V</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">直流电压上限</h1>
          <h2 class="shuzhi ">{{ info.direct_voltage_upper }}<span class="danwei">V</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">充电限流值</h1>
          <h2 class="shuzhi ">{{ info.charge_current }}<span class="danwei">A</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">直流电压下限</h1>
          <h2 class="shuzhi ">{{ info.direct_voltage_lower }}<span class="danwei">V</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">电源厂家</h1>
          <h2 class="shuzhi">{{ info.factory }}</h2>
        </li>

        <li>
          <h1 class="mingcheng">配置</h1>
          <h2 class="shuzhi">{{ info.attribute }}</h2>
        </li>
        <li>
          <h1 class="mingcheng">设备型号</h1>
          <h2 class="shuzhi ">{{ info.model }}</h2>
        </li>
        <li>
          <h1 class="mingcheng">利用率</h1>
          <h2 class="shuzhi ">{{ info.use_rate }}<span class="danwei">%</span></h2>
        </li>

        <li>
          <h1 class="mingcheng">可用备电时长</h1>
          <h2 class="shuzhi ">{{ info.slave_capacity_valid }}<span class="danwei">小时</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">可用调峰时长</h1>
          <h2 class="shuzhi ">{{ info.capacity_peak_valid }}<span class="danwei">小时</span></h2>
        </li>
      </ul>
    </div>
    <div class="quxian">
      电源状态
    </div>
    <div style="padding-left:70px">
      <ZhuangTai :info="info" />
    </div>
  </div>
</template>

<script>

import { defineComponent, } from "vue";
//import * as echarts from 'echarts';
import ZhuangTai from "./ZhuangTai.vue";
export default defineComponent({
  components: { ZhuangTai, },
  props: { info: Object, },
  setup() {

  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xqleft {
  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.quxian {
  background: url("@/assets/biaoti.png") no-repeat;
  font-size: 14px;
  color: #fff;
  font-weight: bold;

  padding-left: 20px;

  margin: 15px 20px;
}

.chengshi {
  padding-top: 36px;
  display: flex;
  padding-left: 30px;
  padding-right: 20px;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-between;
  background: url("@/assets/xian2.png") no-repeat bottom center;
  padding-bottom: 10px;


}



.llist {
  padding: 20px 20px 0;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 100%;
  color: #fff;
  display: flex;
  padding: 5px 10px;
  justify-content: space-between
}

.mingcheng {
  color: #c0c3c9;
  font-size: 15px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 15px;
  padding: 0;
  margin: 0;
  font-weight: bold;
}

.ziti {
  font-size: 24px;
  font-family: "denmark";
}

.danwei {
  color: #2489ff;
  font-size: 12px;
  padding-left: 10px;
  font-weight: bold;
}
</style>
